var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"day datepicker-cell dots",class:_vm.classArray,attrs:{"role":"button"},on:{"click":_vm.onClick,"mouseover":_vm.onHover}},[_vm._v("\n  "+_vm._s(_vm.$moment(_vm.day).format("D"))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }